<div class="review-field pt-4 pb-2">
    <h2 class="head-text">{{reviewItem.garage_name}}</h2>
    <div class="star-rating">
        <star-rating [value]="reviewItem.ratings" [totalstars]="reviewItem.ratings" checkedcolor="#AAD043" uncheckedcolor="#E2E2E2" size="25px" [readonly]="true"></star-rating>
    </div> 
    <p class="comment-text" style="color: #838383">{{reviewItem.comment}}</p>
    <p class="pt-2 head-text has-text-weight-semibold">{{reviewItem.name}}</p>
</div>
